import { combineReducers } from "redux";
import ControleAtendimentoReducer from "./Empresa/reducer";
import LayoutReducer from "./layouts/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  ControleAtendimento: ControleAtendimentoReducer,
});

export default rootReducer;
